<template>
    <div class="nj-input-text">
        <div class="nj-label">{{ label }}</div>
        <div class="nj-flex">
            <input :type="type"
                   class="nj-text"
                   :value="value"
                   :placeholder="placeholder"
                   :disabled="disabled"
                   :tabindex="tabindex"
                   @input="input($event)"
                   @keyup.enter="enter($event)"
                   @keyup="keyup($event)" />
            <slot :value="value"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "InputText",
    props: {
        value: null,
        id: {
            type: String,
            default: "text",
        },
        type: {
            type: String,
            default: "text"
        },
        label: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        tabindex: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        input(event) {
            this.$emit("input", event.target.value == "" ? null : event.target.value)
        },
        enter(event) {
            this.$emit("enter", event)
        },
        keyup(event) {
            this.$emit("keyup", event)
        },
    },
    mounted() {

    },
}
</script>

<style scoped>
.nj-input-text {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    gap: 0;
    width: 100%;
}

.nj-text:disabled {
    background-color: var(--bg-disabled);
}
</style>